import type {Conversation} from "@khan/guide-types";

/**
 * Update the conversation to insert a system message.
 *
 * @param conversation The conversation to be modified.
 * @returns The updated conversation where a system message is appended.
 */
export const updateConversationWithSystemMessage = (
    conversation: Conversation,
    message: string,
    uiOnly: boolean = true,
): Conversation => {
    return [
        ...conversation,
        {
            type: "system",
            text: message,
            user: "System",
            uiOnly: uiOnly,
            serverOnly: false,
            interactionId: "",
        },
    ];
};
